module.exports = __webpack_public_path__ + "static/media/imagePlaceholder.f291c9e9.png";